import { ref } from "vue";
import { usePage } from "@inertiajs/vue3"

export default {
    mounted(el, binding) {
        const editable = ref(usePage().props.editable)

        let items = binding.value.array;
        let index = binding.value.index;
        let tag = el.tagName.toLowerCase(); // Ermittelt den Element-Typ (p, li, etc.)

        el.contentEditable = editable.value;
        el.innerText = items[index];

        el.addEventListener("input", () => {
            items[index] = el.innerText;
        });

        el.addEventListener("keydown", (event) => {
            if (event.key === "Enter") {
                event.preventDefault();

                if (event.shiftKey) {
                    // Shift+Enter: Einfacher Zeilenumbruch
                    document.execCommand("insertLineBreak");
                    return;
                }

                items.splice(index + 1, 0, { id: Math.random().toString(36).substr(2, 9), text: "" });
                binding.instance.$forceUpdate();

                nextTick(() => {
                    el.nextElementSibling?.focus();
                });
            }

            if (event.key === "Backspace" && index > 0) {
                event.preventDefault();

                // Backspace bei leerem Eintrag: Mit vorherigem Eintrag verbinden
                let prevElement = el.previousElementSibling;
                if (prevElement) {
                    let prevIndex = index - 1;
                    items[prevIndex] += " " + items[index]; // Inhalte zusammenfügen
                    items.splice(index, 1); // Aktuellen Eintrag entfernen
                    binding.instance.$forceUpdate();

                    nextTick(() => {
                        prevElement.focus();
                    });
                }
            }
        });
    }
};
